export default __webpack_public_path__ + "static/media/02-standard-white.9047403c.png";